import React from 'react'
import { CFView, CFImage, DefaultScreen, MobileScreen } from 'components'
import { foodGallery, mobileGallery } from 'images'

export default () => {
  return (
    <CFView>
      <MobileScreen>
        <CFView column center mt="-1px">
          <CFImage src={mobileGallery} w="100%" alt="Food Gallery" />
        </CFView>
      </MobileScreen>
      <DefaultScreen>
        <CFView column center maxWidth="1400px" mt="-1px">
          <CFImage src={foodGallery} w="100%" alt="Food Gallery" m="0 auto" />
        </CFView>
      </DefaultScreen>
    </CFView>
  )
}
